import { createReducer, on } from "@ngrx/store";
import { IExame } from "src/app/shared/interfaces/exames/iexame";
import { exameActions } from "./exame.actions";

export interface IExameState {
    lista: IExame[];
    examByID: any;
    isLoading: boolean,
    action: string,
    type: string,
    totalItems: number
}

const initialState: IExameState = {
    lista: [],
    examByID: null,
    isLoading: false,
    action: '',
    type: '',
    totalItems: 0
}

export const exameReducer = createReducer(
    initialState,
    on(
        exameActions.loadExame,
        (state) => ({
            ...state,
            isLoading: true,
            action: 'get',
            type: 'loading'
        })
    ),
    on(
        exameActions.loadExameByID,
        (state) => ({
            ...state,
            isLoading: true
        })
    ),
    on(
        exameActions.loadExameSuccess,
        (state, { lista }) => ({
            ...state,
            isLoading: false,
            lista: [...lista['hydra:member']],
            action: 'get',
            type: 'success',
            totalItems: lista['hydra:totalItems']
        })
    ),
    on(
        exameActions.loadExameError,
        (state) => ({
            ...state,
            action: 'get',
            type: 'error',
            totalItems: 0
        })
    ),
    on(
        exameActions.loadExameByIDSuccess,
        (state, { exam }) => ({
            ...state,
            isLoading: false,
            examByID: exam
        })
    ),
    on(
        exameActions.saveExame,
        (state) => ({
            ...state,
            action: 'save',
            type: 'loading'
        })
    ),
    on(
        exameActions.saveExameSuccess,
        (state) => ({
            ...state,
            action: 'save',
            type: 'success'
        })
    ),
    on(
        exameActions.saveExameError,
        (state) => ({
            ...state,
            action: 'save',
            type: 'error'
        })
    ),
    on(
        exameActions.editExame,
        (state) => ({
            ...state,
            action: 'edit',
            type: 'loading'
        })
    ),
    on(
        exameActions.editExameSuccess,
        (state) => ({
            ...state,
            action: 'edit',
            type: 'success'
        })
    ),
    on(
        exameActions.editExameError,
        (state) => ({
            ...state,
            action: 'edit',
            type: 'error'
        })
    )

)